import { createAxiosApi } from "../Helpers/axiosApiHelper";
import { UserContext } from "../Contexts/UserContext";
import { useContext } from "react";

export function useUserContext(config) {
	const [user, triggerResetUserFromToken] = useContext(UserContext);
	async function login(newAuthToken, handleResponse) {
		const body = { token: newAuthToken };

		try {
			const response = await createAxiosApi("Auth", user, config).post("/login", body);
			// API will set an HttpOnly auth cookie on success. Refresh user state from server.
			if (response && response.status === 200) {
				// Wait until the server-side session is reflected in user state before continuing
				await triggerResetUserFromToken();
				handleResponse(true);
			}
			else {
				logout();
				handleResponse(false);
			}
		}
		catch (error) {
			console.log(error.response);
			logout();
			handleResponse(false);
		}
	}

	function logout() {
		// Ask API to clear server-side cookie, then refresh user state
		createAxiosApi("Auth", user, config).post("/logout").finally(() => triggerResetUserFromToken());
	}

	return {
		login,
		logout,
		triggerResetUserFromToken,
		...user
	};
}

// Frontend does not read or write auth cookies. Authentication cookies are managed by the API.
